import { render, staticRenderFns } from "./FavoriteGalleries.vue?vue&type=template&id=0f7cad9d"
import script from "./FavoriteGalleries.vue?vue&type=script&lang=js"
export * from "./FavoriteGalleries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports